<template>
  <v-container fluid grid-list-md>
    <!-- Dialogo para mostrar informações para o usuário entrar em contato caso queira deletar a conta -->
    <v-dialog v-model="dialogDeleteAccount" @keydown.esc="dialogDeleteAccount = false" max-width="500" scrollable>
      <v-card>
        <v-card-text justify-center>
          <v-layout row wrap justify-center align-center>
            <div class="delete-account-container">
              <h2 class="title-upgrade">Excluir conta!</h2>
              <div class="delete-account-body">
                <div class="text-column">
                  <h3>Entre em contato com nosso suporte ao lado ou pelas opções abaixo!</h3>
                  <br>
                  <span><strong>Telefone: </strong><strong style="color: blue;">(34) 99910-0135</strong></span>
                  <span><strong>Email: </strong><strong style="color: blue;">suporte.sistema@illissolucoes.com.br</strong></span>
                </div>
              </div>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat @click.native="dialogDeleteAccount = false">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Edit-->
    <v-dialog class="highness" v-model="emailDialog"  width="800px">
      <v-card class="mx-auto" v-if="firstStep">
        <v-card-title style="font-weight: bold; font-size: 1.5em;">Editar email</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout>
            <v-flex xs12>
              <v-text-field required prepend-icon="mail" name="mail" label="Digite um novo E-mail" type="text"
                v-model="newEmail"
                :error-messages="errors.collect('mail')"
                data-vv-validate-on="blur"
                @blur="validateEmailBlur(newEmail)"
                v-validate="'required|email'" @keyup.native.enter="sendCode()"
                data-vv-as="E-mail"
                data-vv-delay="1000"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" :loading="loading" color="primary" @click.native="sendCode()">PROSSEGUIR</v-btn>
          <v-btn class="mx-0" :loading="loading" @click.native="closeEmail()">CANCELAR</v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-auto" v-else>
        <v-card-title style="font-weight: bold; font-size: 1.5em;">Confirmar código</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!--<v-layout>-->
            <v-flex xs12><h3>O código foi enviado para o email "{{newEmail}}"</h3></v-flex>
            <v-flex xs12>
              <v-text-field prepend-icon="check" :error-messages="errors.collect('code')" name="codigo" label="Digite o Código"
                            v-model="codigo"
              ></v-text-field>
            </v-flex>
          <!--</v-layout>-->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" :loading="loading" color="primary" @click.native="register()">CONFIRMAR</v-btn>
          <v-btn dark class="gradient" color="primary" @click="sendCode(2)" :loading="loading">REENVIAR CÓDIGO</v-btn>
          <v-btn class="mx-0" @click.native="closeEmail()">CANCELAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-form v-model="valid" ref="form">
      <v-layout wrap justify-center align-center>
        <v-flex grow>
          <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate(`table.${this.entity}.icon`)}}</v-icon>{{formTitle}}</span>
        </v-flex>
        <v-flex v-if="view === 4" shrink>
          <p-edit-btn @onClick="clickEdit">
          </p-edit-btn>
        </v-flex>
        <v-flex v-if="view === 4" shrink>
          <v-btn color="pink" outline @click="openDeleteAccount" style="padding-right: 10px;">
            Excluir conta
            <v-icon style="padding-left: 10px;">delete</v-icon>
          </v-btn>
        </v-flex>
        <!--Management-->
        <v-container fluid grid-list-xs style="padding: 2px" v-if="view === 4">
          <div class="p-gradient">
            <v-layout row wrap>
              <v-flex xs12 md4>
                <div class="p-white text-xs-center">
                  <v-avatar size="150px" v-ripple v-if="!editedItem.photo_path" class="grey lighten-3">
                    <span>Não existe foto</span>
                  </v-avatar>
                  <v-avatar size="150px" v-ripple v-else>
                    <img :src="blobImage?editedItem.photo_path:`${basePath}uploads/users/${editedItem.photo_path}`" alt="avatar">
                  </v-avatar>
                </div>
              </v-flex>
              <v-flex xs12 md8>
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.id_text')}}</div>
                      <div class="p-content" style="word-break: break-all;"> {{editedItem.id_text}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 md12>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.email')}}</div>
                      <div class="p-content" style="word-break: break-all;"> {{editedItem.email}} </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 md6>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.phone')}}</div>
                      <!-- // é usado o this.$auth.user().phone pois o telefone do usuário pode ser alterado em outras telas -->
                      <div class="p-content">{{maskField(this.$auth.user().phone, '(##)#####-####')}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 md6>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.birth')}}</div>
                      <div class="p-content"> {{editedItem.birth}}</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </v-container>
        <!--Create Edit-->
        <v-container fluid grid-list-xs style="padding: 2px" v-else>
          <v-layout row justify-space-between wrap>
            <v-flex xs12 md4>
              <div class="text-xs-center">
                <p-upload-cropped-image v-model="editedItem.photo_path" @changeImage="changeImage">
                  <div slot="activator">
                    <v-avatar size="150px" v-ripple v-if="!editedItem.photo_path" class="grey lighten-3">
                      <span>Clique para adicionar uma foto</span>
                    </v-avatar>
                    <v-avatar size="150px" v-ripple v-else>
                      <img :src="blobImage?editedItem.photo_path:`${basePath}uploads/users/${editedItem.photo_path}`" alt="avatar">
                    </v-avatar>
                  </div>
                </p-upload-cropped-image>
              </div>
            </v-flex>
            <v-flex xs12 md8>
              <v-layout row wrap justify-center align-center>
                <v-flex xs12>
                  <v-text-field maxlength="190" counter="190" ref="autofocus" :label="translate('table.' + entity + '.field.id_text')"
                                :rules="requiredRule(translate('table.' + entity + '.field.id_text'))" v-model="editedItem.id_text"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field maxlength="190" counter="190" ref="autofocus" :label="translate('table.' + entity + '.field.email')"
                                  v-model="editedItem.email" @click="emailDialog = true" readonly>
                      <template v-slot:append-outer>
                        <a @click="emailDialog = true">Editar</a>
                      </template>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field :label="translate('table.' + entity + '.field.phone')"
                                mask='(##) #####-####'
                                v-model="editedItem.phone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <p-date
                    :label="translate('table.' + entity + '.field.birth')"
                    v-model="editedItem.birth"
                  ></p-date>
                </v-flex>
                <!-- <v-flex xs12 md6>
                  <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.username')"
                                v-model="editedItem.username"
                  ></v-text-field>
                </v-flex> -->
                <!-- <v-flex xs12 md6>
                  <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.cpf')"
                                mask='###.###.###-##'
                                v-model="editedItem.cpf"
                  ></v-text-field>
                </v-flex> -->
                <!-- <v-flex xs12 md6>
                  <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.occupation')"
                                v-model="editedItem.occupation"
                  ></v-text-field>
                </v-flex> -->
                <!-- <v-flex xs12 md6>
                  <v-select :label="translate('table.' + entity + '.field.gender')" name="gender"
                            v-model="editedItem.gender" :items="translate('value.user_gender')"></v-select>
                </v-flex> -->
                <!-- <v-flex xs12 md6>
                  <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.language')"
                                v-model="editedItem.language"
                  ></v-text-field>
                </v-flex> -->
                <!-- <v-flex xs12>
                  <vuetify-google-autocomplete
                    ref="address"
                    id="googleMap"
                    v-model="editedItem.googleMap"
                    append-icon="search"
                    :disabled="false"
                    placeholder="Selecione uma Cidade"
                    label="Cidade"
                    types='(cities)'
                    clearable
                    v-on:blur="controlGoogleAutocomplete"
                    v-on:placechanged="getCityData"
                  >
                  </vuetify-google-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-textarea maxlength="10000" counter="10000" :label="translate('table.' + entity + '.field.links')"
                                v-model="editedItem.links"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea maxlength="10000" counter="10000" :label="translate('table.' + entity + '.field.bio')"
                                v-model="editedItem.bio"
                  ></v-textarea>
                </v-flex> -->
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-form>

    <v-layout wrap justify-center align-center v-if="view === 4">
      <v-flex xs12>
        <v-tabs dark color="cyan" v-model="tab" grow class="elevation-1">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab key="0">
            Configurações
          </v-tab>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item key="0">
              <v-card>
                <v-card-text>
                  <user-config></user-config>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-layout class="fab-container" align-center>
      <v-btn v-if="view === 3" color="primary" dark fab @click="saveProcess()">
        <v-icon>{{this.translate('system.button.done.icon')}}</v-icon>
      </v-btn>

      <v-btn fab small v-if="view === 4" to="home">
        <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
      </v-btn>
      <v-btn fab small v-else @click.native="closeUser()">
        <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
      </v-btn>

    </v-layout>
  </v-container>
</template>

<style scoped>
  tr td:last-child {
    min-width: 130px;
  }
  .highness {
    max-height: 50vh;
  }
  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }
  .delete-account-container{
    border: 2px solid #00acc2;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
  }

  .delete-account-container .title-upgrade{
    font-size: 2em;
  }

  .delete-account-body{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
  }

  .text-column{
    display: flex;
    flex-direction: column;
    text-align: left;
  }
</style>

<script>
  import rules from '../mixin/rules'
  import crud from '../mixin/crud'
  import mask from '../mixin/mask'
  import PDate from './shared/PDate'
  import PUploadCroppedImage from './shared/PUploadCroppedImage'
  import UserConfig from './details/UserConfig'
  import PEditBtn from './shared/PEditBtn.vue'

  export default {
    /* eslint-disable eqeqeq */
    mixins: [rules, crud, mask],
    components: {PDate, UserConfig, PUploadCroppedImage, PEditBtn},
    data: () => ({
      entity: 'users',
      codigo: '',
      code: '',
      newEmail: '',
      view: 4,
      fab: null,
      tab: null,
      valid: false,
      loading: false,
      avatar: null,
      saving: false,
      editedItem: {},
      saved: false,
      emailDialog: false,
      firstStep: true,
      image: '',
      blobImage: false,
      dialogDeleteAccount: false,
      basePath: process.env.API
    }),
    created () {
      this.code = Math.floor(Math.random() * (999999 - 100000)) + 100000
      this.editedItem = JSON.parse(JSON.stringify(this.$auth.user()))
      this.defaultItem = {active: true, city: '', state: '', country: '', googleMap: ''}
      setTimeout(() => {
        this.$refs.address.update(`${this.editedItem.city ? this.editedItem.city + `, ` : ``}${this.editedItem.state ? this.editedItem.state + `, ` : ``}${this.editedItem.country || ``}`)
      }, 200)
    },
    watch: {
      avatar: {
        handler: function () {
          this.saved = false
        },
        deep: true
      }
    },
    methods: {
      clickEdit () {
        // pega novamente os dados o user pois algum pode ter alterado como o telefone, que é alterado em outras telas
        this.editedItem = JSON.parse(JSON.stringify(this.$auth.user()))
        this.view = 3
      },
      validateEmailBlur (item) {
        this.newEmail = item.replace(/\s/g, '')
      },
      beforeCreate () {
        // Object.assign(this.defaultItem, {identifier: this.getMaxValue(this.items, 'identifier') + 1})
      },
      controlGoogleAutocomplete () {
        if (document.getElementById('googleMap').value === '') {
          this.$refs.address.clear()
          this.editedItem = Object.assign(this.editedItem, {city: null, state: null, country: null})
        } else {
          let googleMap = this.editedItem.googleMap
          // Inserido o recebimento de vazio, pois quando tenta passar o googleMap direto, considera que o valor é o mesmo e não altera
          this.$refs.address.update(' ')
          // Inserido o tempo para dar tempo do update acima se concluir
          setTimeout(() => {
            this.$refs.address.update(googleMap)
          }, 100)
        }
      },
      getCityData: function (addressData, placeResultData, id) {
        this.address = addressData
        setTimeout(() => {
          this.$refs.address.update(`${addressData.locality || ``}, ${addressData.administrative_area_level_1 || ``}, ${addressData.country || ``}`)
        }, 200)
        this.editedItem = Object.assign(this.editedItem, {city: addressData.locality, state: addressData.administrative_area_level_1, country: addressData.country})
      },
      saveProcess () {
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          })
          return false
        }
        this.$store.commit('loader/change_dialog', true)
        if (this.image) {
          this.$http.post('api/user/upload', this.image).then(res => {
            this.blobImage = false
            this.editedItem.photo_path = res.bodyText
            this.saveValue()
          })
        } else {
          this.saveValue()
        }
      },
      saveValue (value = this.editedItem) {
        this.$http.put(`api/${this.entity}/${this.editedItem.id}`, value).then(
          (res) => {
            this.loading = false
            this.firstStep = true
            this.emailDialog = false
            this.$auth.user(res.body)
            // this.code = ''
            this.codigo = ''
            this.editedItem.email = this.newEmail
            this.newEmail = ''
            this.closeUser()
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro' + (name === '' ? name : ' de ' + name) +
              ' editado com sucesso!',
              color: 'success',
              dialog: true
            })
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.firstStep = true
            this.emailDialog = false
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível incluir o registro' +
              (name === '' ? name : ' de ' + name) + ', reporte o erro.',
              color: 'error',
              dialog: true
            })
          }
        )
      },
      uploadImage () {
        this.saving = true
        setTimeout(() => this.savedAvatar(), 1000)
      },
      closeUser () {
        this.view = 4
        this.editedItem = JSON.parse(JSON.stringify(this.$auth.user()))
      },
      closeEmail () {
        this.emailDialog = false
        this.firstStep = true
        // this.code = ''
        this.codigo = ''
        this.newEmail = ''
        this.errors.clear()
      },
      sendCode (type = 1) {
        this.loading = true
        if (type === 1) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.$http.get('auth/verify_email_register/' + this.newEmail).then((res) => {
                if (parseInt(res.body) === 1) {
                  this.$store.commit('snackbar/change_values', {
                    text: 'Porfavor, corrija as validações para continuar',
                    color: 'warning',
                    dialog: true,
                    timeout: 6000
                  })
                  this.errors.add({
                    field: 'mail',
                    msg: 'Este email já foi cadastrado'
                  })
                  this.loading = false
                  return 0
                } else {
                  this.$http.post(`auth/register_code`, {'user': this.editedItem.id_text, 'email': this.newEmail, 'code': this.code, 'sendEmail': true}).then((res) => {
                    this.firstStep = false
                    this.loading = false
                    this.errors.clear()
                  },
                  (err) => {
                    console.log(err)
                    this.$store.commit('snackbar/change_values', {
                      text: 'Não foi possível enviar o código, porfavor contate o suporte',
                      color: 'error',
                      dialog: true
                    })
                    this.loading = false
                  }
                  )
                }
              })
            } else {
              this.$store.commit('snackbar/change_values', {
                text: 'Por favor, corrija as validações antes de salvar!',
                color: 'error',
                dialog: true
              })
              this.loading = false
            }
          })
        } else {
          this.$http.post(`auth/register_code`, {'user': this.editedItem.id_text, 'email': this.newEmail, 'code': this.code, 'sendEmail': true}).then((res) => {
            console.log(res)
            this.$store.commit('snackbar/change_values', {
              text: 'O código foi reenviado, porfavor confira também a lixeira e a caixa de spam',
              color: 'success',
              dialog: true,
              timeout: 6000
            })
            this.errors.clear()
            this.loading = false
          },
          (err) => {
            console.log(err)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível enviar o código, porfavor contate o suporte',
              color: 'error',
              dialog: true
            })
            this.loading = false
          }
          )
        }
      },
      register: function () {
        this.loading = true
        // è usado o != pois um vem como string e outro integer
        if (this.codigo != this.code) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          this.errors.add({
            field: 'code',
            msg: 'Código incorreto'
          })
          this.loading = false
          return 0
        }
        this.$store.commit('loader/change_dialog', true)
        this.saveValue({email: this.newEmail})
      },
      changeImage (val) {
        this.image = val
        this.blobImage = true
      },
      openDeleteAccount () {
        document.getElementById('purechat-btn').click()
        this.dialogDeleteAccount = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/User.vue